module.exports = __webpack_public_path__ + "static/media/github-heart.2d884f09.svg";